<template>
    <div class="searchbar-wrapper">

        <input class="searchbar" type="text" v-model="searchInput" v-on:submit="doSearch" v-on:keypress.enter="doSearch" :placeholder="'Search'">
    </div>
</template>

<script>
    export default {
        name: "SearchBar",

        data: function () {
            return {
                searchInput: ''
            }
        }
        ,
        methods: {
            doSearch: function () {
                if (this.searchInput.split(" ").join("").length > 2) {
                    this.$store.dispatch('GET_SEARCH_RESULTS_FROM_API', this.searchInput).then(() => {
                        console.log(this.$route)
                        if (this.$route.name != 'SearchResults') {
                            this.$router.push({name: 'SearchResults'})

                        } else {

                        }
                    })
                } else {
                    alert("please search for a minimum of 3 characters.")
                }


            }
        }
    }
    //    todo also requires name search
</script>

<style scoped lang="scss">
    .searchbar-wrapper {
        padding-right: 1em;

    }

    .searchbar {
        border: 1px solid gray;
        width: 100%;


        &:focus {
            border: 1px solid gray;

        }
    }
</style>

